import UserContext from "../../../context/UserContext";
import { useContext } from "react";
function SupportItems(props) {
  const { isLogged, userData } = useContext(UserContext);
  const { role } = userData;
  return (
    <>
      <li className="active">
        <div className="gap-4 text-lg p-5 active rounded-md flex flex-col items-center ">
          <div className="flex justify-start w-full gap-4">
            <h3>{props.type}: </h3> <a href={`${props.url}`}>{props.name}</a>
          </div>
          {isLogged && role === "admin" && (
            <div className="w-full flex justify-center gap-5 ">
              <button
                className="btn hover:bg-red-400 text-red-600 w-20"
                onClick={props.onDelete}
              >
                Delete
              </button>
              <button
                onClick={props.onStartEdit}
                className="btn text-blue-600 hover:bg-blue-400 w-20"
              >
                Edit
              </button>
            </div>
          )}
        </div>
      </li>
    </>
  );
}

export default SupportItems;
